import { Deal } from '../models/shared/Deal';
import { textApplyVariables, useText } from '../context/TextContext';
import { AuditDealRecord, AuditDealRecordStepChange } from '../models/shared/DealAuditRecord';
import { useOrganization } from '../context/OrganizationContext';
import ActionLog, { ActionLogItem } from './ActionLog';

interface Props {
    deal: Deal;
    className?: string;
}

export default function DealAuditLog(props: Props) {
    const text = useText();
    const { organization } = useOrganization();

    const records = props.deal?.auditRecords ? [...props.deal.auditRecords] : [];
    records.reverse();

    const renderMessage = (record: AuditDealRecord) => {
        if (record.type === 'stepChange') {
            const stepChangeRecord = record as AuditDealRecordStepChange;

            const orgSteps = organization.dealSteps || [];
            const oldStep = orgSteps.find(step => step.id === stepChangeRecord.extras.oldStepId)?.name || '';
            const newStep = orgSteps.find(step => step.id === stepChangeRecord.extras.newStepId)?.name || '';

            let message = textApplyVariables(text.createdIn, { step: newStep });
            if (oldStep) {
                message = textApplyVariables(text.movedFromTo, { from: oldStep, to: newStep });
            }
            return message;

        } else {
            return ''
        }
    }

    const actions: ActionLogItem[] = records.map(record => ({
        text: renderMessage(record),
        date: record.createdAt
    }));

    return (
        <div className={props.className}>
            <h6>{text.actions}</h6>
            <ActionLog actions={actions} />
        </div>
    )
}
